import { Injectable, Optional } from '@angular/core';


// Angular material
import { MatDialog } from '@angular/material/dialog'

// Generic dialogs
import { InformationPopupComponent } from '../../components/popups/information-popup/information-popup.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    @Optional() public dialog:MatDialog,
  ) {}


  // ----- Generic Dialogs ----- //
  displayInformationPopup(popupTitle:string, popupText:string){
    this.dialog.open(
      InformationPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',  
      } 
    )
  }


}
